module.exports = __webpack_public_path__ + "img/pic-3.95a6ff4b.png";